const aws = require("aws-sdk");
const cookie = require("cookie");

export default (req, res, next) => {
    if (process.env.ASSET_SIGNING_KEY_PAIR_ID && process.env.ASSET_SIGNING_PRIVATE_KEY) {
        const signer = new aws.CloudFront.Signer(process.env.ASSET_SIGNING_KEY_PAIR_ID, process.env.ASSET_SIGNING_PRIVATE_KEY);

        const policy = JSON.stringify({
            Statement: [
                {
                    Resource: "http*://assets.deploy-preview.procreate.art/*", // http* => http and https
                    Condition: {
                        DateLessThan: {
                            "AWS:EpochTime": Math.floor(new Date().getTime() / 1000) + 60 * 60 * 1, // Current Time in UTC + time in seconds, (60 * 60 * 1 = 1 hour)
                        },
                    },
                },
            ],
        });

        const signedCookie = signer.getSignedCookie({
            policy,
        });

        const cookieOptions = {
            domain: ".deploy-preview.procreate.art",
            path: "/",
            httpOnly: true,
            secure: true,
        };

        res.setHeader("Set-Cookie", [
            cookie.serialize("CloudFront-Key-Pair-Id", signedCookie["CloudFront-Key-Pair-Id"], cookieOptions),
            cookie.serialize("CloudFront-Policy", signedCookie["CloudFront-Policy"], cookieOptions),
            cookie.serialize("CloudFront-Signature", signedCookie["CloudFront-Signature"], cookieOptions),
        ]);
    }

    next();
};
